import { render, staticRenderFns } from "./ConfirmClose.vue?vue&type=template&id=6acbbf24&"
import script from "./ConfirmClose.vue?vue&type=script&lang=js&"
export * from "./ConfirmClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports